import styled from 'styled-components';

export const WhatsappLink = styled.a`
  > img {
    width: 16px;
    height: 16px;
  }
`;